import { BaseController } from "@/app/controller/BaseController";
import { Signal } from "@/data/util/Signal";


export class PaymentMethodReportController extends BaseController {

    public onShowServices?: { () };
    
    static onInit = new Signal();
    static onShown = new Signal();
    static onHidden = new Signal();
    static onShowServices = new Signal();
    static onUpdateData = new Signal();
    
    constructor() {
        super("payment-methods-report");

        PaymentMethodReportController.onInit.dispatch();
        PaymentMethodReportController.onShowServices.add(this.showServices, this);
    }
    
    public triggerDataUpdate() {
        PaymentMethodReportController.onUpdateData.dispatch();
    }

    protected onBecomeVisible() {
        PaymentMethodReportController.onShown.dispatch();
    }

    protected onBecomeInvisible() {
        PaymentMethodReportController.onHidden.dispatch();
    }

    protected showServices() {
        if (this.onShowServices) {
            this.onShowServices();
        }
    }
}